import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import type { LlmCostRunningJob } from '@/lib/types/dashboard/llmCost';
import { elapsedMs, formatDateTime, formatDurationMs, formatTab } from './format';

/** 実行中ジョブ（running）の経過と制限時間までの残り */
export function LlmCostRunningPanel({ jobs, now }: { jobs: LlmCostRunningJob[]; now: Date }) {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" mb={1}>
        実行中のジョブ
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block" mb={1}>
        期間フィルタに関係なく現在実行中のジョブを表示する。作成から制限時間を過ぎると sweeper が
        timeout として停止する。キャンセルはカスタムダッシュボードのタブ設定画面から行う。
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>アカウント / タブ</TableCell>
              <TableCell>開始</TableCell>
              <TableCell align="right">経過</TableCell>
              <TableCell align="right">制限時間まで</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {jobs.map((job) => {
              const remaining = new Date(job.expiresAt).getTime() - now.getTime();
              return (
                <TableRow key={job.jobId}>
                  <TableCell>
                    {job.accountCode} / {formatTab(job.tabId, job.tabName)}
                  </TableCell>
                  <TableCell>{formatDateTime(job.createdAt)}</TableCell>
                  <TableCell align="right">
                    {formatDurationMs(elapsedMs(job.createdAt, now))}
                  </TableCell>
                  <TableCell align="right">
                    {remaining > 0 ? formatDurationMs(remaining) : '超過'}
                  </TableCell>
                </TableRow>
              );
            })}
            {jobs.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  実行中のジョブはありません
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
